<template>
  <form class="gp-forms" />
</template>

<script>
export default {
  name: "GpForms"
};
</script>

<style lang="scss">
// @import "./styles.scss";
</style>
